import { compareDates, formatDate } from '../common/formatDate';
import { DATE_FORMAT_ISO } from '../constants/dateFormat';

export function makeNoSoonerThenValidator<T>(
  errorMsg: T,
  getMinDate: () => string | undefined,
  valueParseFormat?: string,
) {
  return (value: string) => {
    const minDate = getMinDate();
    if (!minDate) {
      return undefined;
    }
    if (
      compareDates({
        dateLeft: formatDate({
          date: value,
          dateFormat: DATE_FORMAT_ISO,
          parseFormat: valueParseFormat,
        }),
        dateRigth: formatDate({ date: minDate, dateFormat: DATE_FORMAT_ISO }),
      }) === -1
    ) {
      return errorMsg;
    }
    return undefined;
  };
}
